import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@orisini/ui/components/card'
import { api, ApiError } from '@orisini/ui/lib/api'
import { useAuth } from '@orisini/ui/context/AuthContext'

export default function VerifyEmailPage() {
  const [params] = useSearchParams()
  const { refresh } = useAuth()
  const token = params.get('token') ?? ''
  const [state, setState] = useState<'working' | 'ok' | 'error'>('working')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) {
      setState('error')
      setMessage('Incomplete verification link.')
      return
    }
    api
      .post('/auth/verify-email', { token })
      .then(() => {
        setState('ok')
        return refresh().catch(() => undefined)
      })
      .catch((err: unknown) => {
        setState('error')
        setMessage(
          err instanceof ApiError
            ? `${err.message} The link can only be used once.`
            : "Couldn't verify email.",
        )
      })
  }, [token, refresh])

  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Verify email</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm">
          {state === 'working' && <p className="text-muted-foreground">Verifying…</p>}
          {state === 'ok' && <p className="text-emerald-500">Your email has been verified.</p>}
          {state === 'error' && <p className="text-destructive">{message}</p>}
          <Link to="/" className="inline-block text-foreground hover:underline">
            Continue to the app
          </Link>
        </CardContent>
      </Card>
    </main>
  )
}
